export default __webpack_public_path__ + "static/media/Learnry_04.4cf54126.png";